// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ISaveUserRoleRequestModel {
    'userName': string;
    'role': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ISaveUserRoleRequestModel>> = [
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "role",
            "baseName": "role",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ISaveUserRoleRequestModel.attributeTypeMap;
    }
}
